export default [
    { value:  1  , title:  '1 hr 0 min'  },
    { value:  1.5, title:  '1 hr 30 min' },
    { value:  2  , title:  '2 hr 0 min'  },
    { value:  2.5, title:  '2 hr 30 min' },
    { value:  3  , title:  '3 hr 0 min'  },
    { value:  3.5, title:  '3 hr 30 min' },
    { value:  4  , title:  '4 hr 0 min'  },
    { value:  4.5, title:  '4 hr 30 min' },
    { value:  5  , title:  '5 hr 0 min'  },
    { value:  5.5, title:  '5 hr 30 min' },
    { value:  6  , title:  '6 hr 0 min'  },
    { value:  6.5, title:  '6 hr 30 min' },
    { value:  7  , title:  '7 hr 0 min'  },
    { value:  7.5, title:  '7 hr 30 min' },
    { value:  8  , title:  '8 hr 0 min'  },
    { value:  8.5, title:  '8 hr 30 min' },
    { value:  9  , title:  '9 hr 0 min'  },
    { value:  9.5, title:  '9 hr 30 min' },
    { value: 10  , title: '10 hr 0 min'  },
    { value: 10.5, title: '10 hr 30 min' },
    { value: 11  , title: '11 hr 0 min'  },
    { value: 11.5, title: '11 hr 30 min' },
    { value: 12  , title: '12 hr 0 min'  },
    { value: 12.5, title: '12 hr 30 min' },
    { value: 13  , title: '13 hr 0 min'  },
    { value: 13.5, title: '13 hr 30 min' },
    { value: 14  , title: '14 hr 0 min'  },
    { value: 14.5, title: '14 hr 30 min' },
    { value: 15  , title: '15 hr 0 min'  },
    { value: 15.5, title: '15 hr 30 min' },
    { value: 16  , title: '16 hr 0 min'  },
    { value: 16.5, title: '16 hr 30 min' },
    { value: 17  , title: '17 hr 0 min'  },
    { value: 17.5, title: '17 hr 30 min' },
    { value: 18  , title: '18 hr 0 min'  },
    { value: 18.5, title: '18 hr 30 min' },
    { value: 19  , title: '19 hr 0 min'  },
    { value: 19.5, title: '19 hr 30 min' },
    { value: 20  , title: '20 hr 0 min'  },
    { value: 20.5, title: '20 hr 30 min' },
    { value: 21  , title: '21 hr 0 min'  },
    { value: 21.5, title: '21 hr 30 min' },
    { value: 22  , title: '22 hr 0 min'  },
    { value: 22.5, title: '22 hr 30 min' },
    { value: 23  , title: '23 hr 0 min'  },
    { value: 23.5, title: '23 hr 30 min' },
    { value: 24  , title: '24 hr 0 min'  },
]
